<template>
  <div style="background-color: #F0F0F0">
    <div class="seat">
        <div class="seat-logo">
          <div class="logo-text">VIP</div>
        </div>
        <div class="seat-box">
          <div>
          <p class="seat-title">VIP석</p>
          <p class="seat-subTitle">- 위치 : 본부석 정중앙 2층</p>
          <p class="seat-subTitle">- 입장게이트 : 정문 게이트</p>
          <div class="seat-desc">
            좌석 간격이 넓고 경기장 지붕 아래 정중앙에 위치하여 비와 지와선 차단 및 시야가 좋은 좌석
          </div>
          </div>
          <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.vip === idx}"
                  @click="tabIndexChange(currentTab.vip); setSlideNum('vip')"
                  @click.prevent="currentTab.vip = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_v" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[0][btnList[currentTab.vip].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          </div>
        </div>
      </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">테이블</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">T1 테이블석</p>
          <p class="seat-subTitle">- 위치 : 본부석 기준 좌측 T1</p>
          <p class="seat-subTitle">- 입장게이트 : 서1문 게이트</p>
          <div class="seat-desc">
            지붕 아래 및 홈팀 벤치 뒤에 위치하고 있으며 2인 테이블이 배치되어 가족/지인과 함께
            음식을 먹으며 편하게 경기 관람이 가능한 좌석
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.table === idx}"
                  @click="tabIndexChange(currentTab.table); setSlideNum('table')"
                  @click.prevent="currentTab.table = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_t" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[1][btnList[currentTab.table].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">테이블석</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">T3 테이블석(익사이팅 테이블 치킨존)</p>
          <p class="seat-subTitle">- 위치 : 본부석 정중앙 1층</p>
          <p class="seat-subTitle">- 입장게이트 : 서1문 게이트</p>
          <div class="seat-desc">
            좌석 간격이 넓고 2인 테이블이 배치되어 있으며,
            가족/지인과 함께 음식을 먹으며 편하게 경기 관람이 가능한 좌석.<br>
            또한 경기를 더욱 가까이에서 관람하여 경기장의 열기를 직접적으로 느낄 수 있는 좌석.<br>
            사전 예매 시 치킨 제공
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.table3 === idx}"
                  @click="tabIndexChange(currentTab.table3); setSlideNum('table3')"
                  @click.prevent="currentTab.table3 = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_t3" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[2][btnList[currentTab.table3].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">피크닉석</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">피크닉석</p>
          <p class="seat-subTitle">- 위치 : W석-N석 사이 2층</p>
          <p class="seat-subTitle">- 입장게이트 : 서1문 게이트</p>
          <div class="seat-desc">
            4인석, 6인석으로 구분되어 있으며 가족/지인과 함께 음식을 먹으며 편하게 경기 관람이 가능한 좌석, 사전 예매 시 치킨 제공
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList_2" :key="idx"
                  :class="{active:currentTab.picnic === idx}"
                  @click="tabIndexChange(currentTab.picnic); setSlideNum('picnic')"
                  @click.prevent="currentTab.picnic = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_p" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[3][btnList_2[currentTab.picnic].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">W석</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">W석</p>
          <p class="seat-subTitle">- 위치 : 본부석 기준 좌/우 W구역</p>
          <p class="seat-subTitle">- 입장게이트 : 서1문 게이트</p>
          <div class="seat-desc">
            선수단 출입구, 벤치와 가장 가깝게 위치하여 경기의 현장감과 분위기를 잘 느낄 수 있고
            선수단을 가장 가까이서 볼 수 있는 좌석<br>
            좌석 간 간격이 넓어 편안한 관람이 가능한 좌석
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.wSeat === idx}"
                  @click="tabIndexChange(currentTab.wSeat); setSlideNum('W')"
                  @click.prevent="currentTab.wSeat = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_w" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[4][btnList[currentTab.wSeat].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">스탠딩</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">N석 (스탠딩석)</p>
          <p class="seat-subTitle">- 위치 : N1구역</p>
          <p class="seat-subTitle">- 입장게이트 : 북문 게이트</p>
          <div class="seat-desc">
            서포터즈와 응원하며 경기를 즐길 수 있는 좌석<br>
            코너 플래그 쪽에 위치하여 전체적인 경기 흐름을 파악하기 좋은 좌석
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.standing === idx}"
                  @click="tabIndexChange(currentTab.standing); setSlideNum('standing')"
                  @click.prevent="currentTab.standing = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_standing" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[5][btnList[currentTab.standing].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">N석</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">N석</p>
          <p class="seat-subTitle">- 위치 : N구역 1,2층</p>
          <p class="seat-subTitle">- 입장게이트 : 북문 게이트</p>
          <div class="seat-desc">
            골대와 가장 가깝게 위치하여 페널티 박스 안 치열한 상황을 가장 생생하게 느낄 수 있고,<br>
            경기장 전체 시야확보가 가능한 좌석
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.nSeat === idx}"
                  @click="tabIndexChange(currentTab.nSeat); setSlideNum('N')"
                  @click.prevent="currentTab.nSeat = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_n" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[6][btnList[currentTab.nSeat].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">E석</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">E석</p>
          <p class="seat-subTitle">- 위치 : E구역 1,2층</p>
          <p class="seat-subTitle">- 입장게이트 : 동문 게이트</p>
          <div class="seat-desc">
            가장 많은 좌석이 배치되어 있어 취향에 맞게 좌측, 중앙, 우측 좌석을 선택하여 경기를 관람할 수 있는 좌석
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.eSeat === idx}"
                  @click="tabIndexChange(currentTab.eSeat); setSlideNum('E')"
                  @click.prevent="currentTab.eSeat = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_e" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[7][btnList[currentTab.eSeat].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="seat">
      <div class="seat-logo">
        <div class="logo-text">S석</div>
      </div>
      <div class="seat-box">
        <div>
          <p class="seat-title">S석</p>
          <p class="seat-subTitle">- 위치 : E구역, 원정석 사이</p>
          <p class="seat-subTitle">- 입장게이트 : 동문 게이트</p>
          <div class="seat-desc">
            코너 플래그 쪽에 위치하여 전체적인 경기 흐름을 파악하기 좋은 좌석
          </div>
        </div>
        <div class="tab-btn-box">
          <div class="tab-box-line">
            <ul class="tab-btn-list">
              <li v-for="(el, idx) in btnList" :key="idx"
                  :class="{active:currentTab.sSeat === idx}"
                  @click="tabIndexChange(currentTab.sSeat); setSlideNum('S')"
                  @click.prevent="currentTab.sSeat = idx"
              ><span>{{el.name}}</span>
              </li>
            </ul>
          </div>
          <div>
            <swiper ref="swiper_s" :options="swiperOption" class="seat-swiper">
              <swiper-slide
                  v-for="(item, index) in list[8][btnList[currentTab.sSeat].type]"
                  :key="index"
                  class="">
                <div class="seatImgBox">
                  <img :src="item" alt="">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

export default {
  name: 'Seats',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 1,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      swiperPause: true,
      list: [
        {
          location: [
            require('@/assets/img/seats/vip_location.png')
          ],
           guide: [
             require('@/assets/img/seats/vip_guide_2.png')
           ],
           sight: [
             require('@/assets/img/seats/vip_sight_1.png')
           ]
        },
        {
            location: [
              require('@/assets/img/seats/table_location.png')
            ],
            guide: [
              require('@/assets/img/seats/table_guide_1.png'),
            ],
            sight: [
              require('@/assets/img/seats/table_sight_1.png')
            ]
        },
        {
          location: [
            require('@/assets/img/seats/table3_location.png')
          ],
          guide: [
            require('@/assets/img/seats/table3_guide_1.jpg'),
          ],
          sight: [
            require('@/assets/img/seats/table3_sight_1.jpg')
          ]
        },
        {
          guide: [
            require('@/assets/img/seats/picnic_guide_1.jpg'),
          ],
          sight: [
            require('@/assets/img/seats/picnic_sight_1.jpg')
          ]
        },
        {
          location: [
            require('@/assets/img/seats/w_location.png')
          ],
          guide: [
            require('@/assets/img/seats/w_guide_1.png'),
            require('@/assets/img/seats/w_guide_2.png'),
          ],
          sight: [
            require('@/assets/img/seats/w_sight_1.png'),
            require('@/assets/img/seats/w_sight_2.png'),
          ]
        },
        {
          location: [
            require('@/assets/img/seats/standing_location.png')
          ],
          guide: [
            require('@/assets/img/seats/standing_guide_1.png'),
          ],
          sight: [
            require('@/assets/img/seats/standing_sight_1.png'),
          ]
        },
        {
          location: [
            require('@/assets/img/seats/n_location.png')
          ],
          guide: [
            require('@/assets/img/seats/n_guide_1.png'),
          ],
          sight: [
            require('@/assets/img/seats/n_sight_1.png'),
            require('@/assets/img/seats/n_sight_2.png')
          ]
        },
        {
          location: [
            require('@/assets/img/seats/e_location.png')
          ],
          guide: [
            require('@/assets/img/seats/e_guide_1.png'),
          ],
          sight: [
            require('@/assets/img/seats/e_sight_1.png'),
            require('@/assets/img/seats/e_sight_2.png'),
            require('@/assets/img/seats/e_sight_3.png')
          ]
        },
        {
          location: [
            require('@/assets/img/seats/s_location.png')
          ],
          guide: [
            require('@/assets/img/seats/s_guide_1.png'),
          ],
          sight: [
            require('@/assets/img/seats/s_sight_1.png'),
          ]
        }
      ],
      btnList : [
        {name: '좌석 위치', type: 'location'},
        {name: '좌석 안내', type: 'guide'},
        {name: '좌석 시야', type: 'sight'}
      ],
      btnList_2 : [
        {name: '좌석 안내', type: 'guide'},
        {name: '좌석 시야', type: 'sight'}
      ],
      currentTab : {
        vip: 0,
        table: 0,
        table3: 0,
        picnic: 0,
        wSeat: 0,
        standing: 0,
        nSeat: 0,
        eSeat: 0,
        sSeat: 0,
      }
    }
  },
  mounted () {
  },
  methods: {
    tabIndexChange(val) {
    },
    setSlideNum (type) {
      if (type === 'vip') {
        this.$refs.swiper_v.$swiper.slideTo(1)
      }
      if (type === 'table') {
        this.$refs.swiper_t.$swiper.slideTo(1)
      }
      if (type === 'table3') {
        this.$refs.swiper_t3.$swiper.slideTo(1)
      }
      if (type === 'picnic') {
        this.$refs.swiper_p.$swiper.slideTo(1)
      }
      if (type === 'W') {
        this.$refs.swiper_w.$swiper.slideTo(1)
      }
      if (type === 'standing') {
        this.$refs.swiper_standing.$swiper.slideTo(1)
      }
      if (type === 'E') {
        this.$refs.swiper_e.$swiper.slideTo(1)
      }
      if (type === 'N') {
        this.$refs.swiper_n.$swiper.slideTo(1)
      }
      if (type === 'S') {
        this.$refs.swiper_s.$swiper.slideTo(1)
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
